<template>
  <Loader :value="promises.fetchOne" class="product-form-wrapper">
    <ProductForm v-model="data" theme="flat" @submit="submit" :disabledFields="disabledFields">
      <template #banner>
        <Alert v-if="isLocked" theme="error">{{ $t('productLockedAlert') }}</Alert>
      </template>
      <template #footer="{ validator }">
        <div class="product-form-wrapper__footer-actions">
          <AffectedShops v-if="!isNew && !isLocked" :item="item" />
          <ButtonComponent :label="$t('cancel')" :icon="['fal', 'times']" @click="$emit('reset-options')" />
          <ButtonComponent
            type="submit"
            :promise="createOptions && createOptions.promise"
            :label="$t('confirm')"
            :icon="['fal', 'check']"
            :disabled="!validator.passes || isLocked"
            theme="primary"
          />
        </div>
        <div v-if="!isNew" class="product-form-wrapper__last-updated">
          {{ $t('lastUpdated') }} {{ item.updatedAt | Moment('DD. MMM YYYY HH:mm') }}
        </div>
      </template>
    </ProductForm>
  </Loader>
</template>

<script>
import { Moment } from '@/filters'
import ModelMixin from '@/mixins/Model'
import Model from '@/models/Product'
import { mapActions, mapState, mapMutations } from 'vuex'
import ProductForm from '@/components/Product/Form'
import { AlertComponent as Alert } from 'vue-elder-alert'
import { DropdownComponent } from 'vue-elder-dropdown'
import AffectedShops from '@/components/Product/AffectedShops.vue'

export default {
  mixins: [
    ModelMixin({
      model(data, options) {
        return Model(data, options)
      },
      guard: true,
      transform: {
        products: v => (v && v.length ? v.map(e => e.id) : null),
      },
    }),
  ],
  name: 'ProductFormWrapper',
  props: {
    id: String,
    createOptions: Object,
  },
  data() {
    return {
      data: {},
    }
  },
  watch: {
    id: {
      handler(id = '') {
        if (this.createOptions.product && !id) return this.set(this.createOptions.product)
        if (!id) return this.set({})
        return this.fetch({ id })
      },
      immediate: true,
    },
  },
  provide() {
    return {
      getData: this.getData,
    }
  },
  computed: {
    ...mapState('Product', ['item', 'promises']),
    isLocked() {
      return !!this.$path('item.metadata.isLocked')
    },
    disabledFields() {
      return this.$path('item.metadata.disabledFields')
    },
    isNew() {
      return !this.id
    },
  },
  methods: {
    ...mapActions('Product', ['fetch']),
    ...mapMutations('Product', ['set']),
    submit() {
      if (this.isLocked) return
      this.$emit('submit', this.data)
    },
  },
  filters: {
    Moment,
  },
  components: {
    AffectedShops,
    ProductForm,
    Alert,
    DropdownComponent,
  },
}
</script>

<style lang="scss">
.product-form-wrapper {
  margin: 0 auto;
  max-width: 1000px;
  background-color: white;
  border-radius: var(--border-radius);
  padding-bottom: 1rem;
  padding: var(--card-spacing);

  &__last-updated {
    opacity: 0.7;
    font-size: 0.8em;
    letter-spacing: 0.25px;
    text-align: right;
    width: 100%;
  }

  &__footer {
    width: 100%;

    &-actions {
      display: flex;
      justify-content: flex-end;
      align-items: center;
      gap: 1rem;
      width: 100%;
    }
  }

  .card {
    &__footer {
      padding: 0 2.5rem;
      padding-bottom: var(--card-spacing);

      &-content {
        display: flex;
        justify-content: space-between;
      }

      .affected-shops {
        flex-grow: 1;
      }
    }
  }
}
</style>
